export enum NoiseSpeedType {
    Slow = 0,
    Fast = 1
}